import Candidates from './candidates'
import Committee from './committee'
import Dashboard from './dashboard'
import Tracking from './tracking'
import User from './user'

export default {
  CandidatesStore: Candidates,
  CommitteeStore: Committee,
  DashboardStore: Dashboard,
  TrackingStore: Tracking,
  UserStore: User
}
